module.exports = __webpack_public_path__ + "img/superscript.2eec9534.svg";